import type { FaireProductEntity } from "../../entity_types/product";

export const p_pvqudgu73r: FaireProductEntity = {
  token: "p_pvqudgu73r",
  type: "product",
  name: "Ionic Liquid Selenium",
  brandToken: "b_n34zp8ykn9",
  brandName: "Eidon Ionic Minerals",
  imageUrl:
    "https://cdn.faire.com/fastly/b1bef4bf51d031ed327e894eacfcf3491905ec827a42d4cfeeb496d74e45264e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3fdb862d075a8af3dec63532c35cf572053608cbe0c6849f7563557f70227fe8.jpeg",
    "https://cdn.faire.com/fastly/ce0b3ce056e5a12aa60473fe154c5715d9c845bb5b930fc30cc6e63731d8f21f.jpeg",
  ],
  priceDollars: 16.63,
  description:
    "Selenium, while little known by the public, is a well-studied element. It is involved as a catalyst in several important enzymes.\n\nThe most well-known function is in the liver, where selenium catalyzes or activates the glutathione peroxidase enzyme. This enzyme plays its most significant role in the liver as it cleanses the blood. Without it, the liver could not do its job properly, leaving our system full of toxins.\nSelenium plays an important role in the thyroid, where, along with Iodine, it catalyzes the T4 and T3 enzymes, which are critical for energy production. Along with the thyroid, Selenium is also found in healthy breast and prostate tissues. Selenium is not widespread in the Earth’s soils. Consequently, the ability to obtain Selenium in our foods regularly is difficult. Supplementation is the best way to ensure a steady supply, and a steady supply is essential for optimal health. Selenium helps support a healthy immune system, thyroid and liver function, breast and prostate.",
  tags: [],
  msrpDollars: 27.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:59.898Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
